import * as React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { Checkbox, Hidden, Strong, Text, Visible } from 'main/ui'
import { IFilters } from 'main/util/search'
import { useTranslation } from 'react-i18next'
import {
  Apply,
  CheckboxGroupContainer,
  Clear,
  FieldCopyContainer,
  FieldsContainer,
  FilterFormContainer,
  FilterFormSubmitContainer,
} from '../../common/FilterForm.styles'
import { ISearchFormProps } from '../../types'

const PRE = `${i18nKeyPrefix}-FILTERS-TOURS-FORM`
const filterCopy = `${PRE}-FILTER`

export default function FilterForm(props: ISearchFormProps) {
  const { filters, onChangeFilters, onRequestCloseForm } = props

  const [params, setParams] = React.useState<IFilters>({ ...filters })

  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <FilterFormContainer>
      <Visible lg xl>
        <Strong>{t(filterCopy)}</Strong>
      </Visible>
      <Fields params={params} onChangeParams={setParams} />
      <Visible lg xl>
        <FilterFormSubmitContainer>
          <Clear data-pendo="toursAndEventsFilter-clear" onClick={() => handleClear()}>
            {t(`${PRE}-CLEAR`)}
          </Clear>
          <Apply data-pendo="toursAndEventsFilter-apply" onClick={() => handleApply()}>
            {t(`${PRE}-APPLY`)}
          </Apply>
        </FilterFormSubmitContainer>
      </Visible>
    </FilterFormContainer>
  )

  function handleApply() {
    onRequestCloseForm()
    onChangeFilters({
      ...filters,
      hasUpcomingGatherings: params.hasUpcomingGatherings,
      isTouring: params.isTouring,
    })
  }

  function handleClear() {
    setParams({ ...params, hasUpcomingGatherings: false, isTouring: false })
  }
}

interface IFieldsProps {
  params: IFilters
  onChangeParams: (params: IFilters) => void
}

export function Fields(fieldsProps: IFieldsProps) {
  const { params, onChangeParams } = fieldsProps
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <Hidden lg xl>
        <FieldCopyContainer>
          <Text>
            <Strong>{t(`${PRE}-TITLE`)}</Strong>
            {t(filterCopy)}
          </Text>
        </FieldCopyContainer>
      </Hidden>
      <FieldsContainer>
        <CheckboxGroupContainer>
          <Checkbox
            data-pendo="toursAndEventsFilter-areCurrentlyTouing"
            checked={params.isTouring}
            label={t(`${PRE}-TOUR`)}
            onChange={(checked: boolean) => onChangeParams({ ...params, isTouring: checked })}
          />
          <Checkbox
            data-pendo="toursAndEventsFilter-haveUpcomingEvents"
            checked={params.hasUpcomingGatherings}
            label={t(`${PRE}-EVENT`)}
            onChange={(checked: boolean) =>
              onChangeParams({ ...params, hasUpcomingGatherings: checked })
            }
          />
        </CheckboxGroupContainer>
      </FieldsContainer>
    </div>
  )
}
